import {BasicClient} from '@/utils/httpClient';
import {AxiosPromise} from "axios";

export default class Mfa {
    client: BasicClient;

    constructor() {
        this.client = new BasicClient();
    }

    /**
     * Envía el código de verificación al correo del usuario quien consume
     */
    sendEmailVerificationCode() {
        return this.client.exec(`/v2/auth-mod/mfa/generateEmailVerificationCode`, 'POST');
    }

    sendVerificationCode() {
        return this.client.exec(`/v2/auth-mod/mfa/generateAuthCode`, 'POST');
    }

    validateAuthCode(code) {
        const params = { code: code }
        return this.client.exec(`/v2/auth-mod/mfa/validateAuthCode`, 'POST', params)
    }
    validateAuthCodeFromEmail(code) {
        const params = { code: code }
        return this.client.exec(`/v2/auth-mod/mfa/validateEmailVerificationCode`, 'POST', params)
    }

    getProfilePreference() {
        return this.client.exec(`/v2/auth-mod/mfa/profilePreference`, 'GET')
    }

    saveProfilePreference(profileId, mfaId) {
        return this.client.exec(`/v2/auth-mod/mfa/profilePreference`, 'POST', {profileId, mfaId})
    }

    deleteProfilePreference(profileId, mfaId) {
        return this.client.exec(`/v2/auth-mod/mfa/profilePreference`, 'DELETE', {profileId, mfaId})
    }

    getResendStatus() {
        return this.client.exec(`/v2/auth-mod/mfa/resendStatus`, 'GET')
    }

}